module.exports = __webpack_public_path__ + "static/media/KaTeX_Script-Regular.af7bc98b.woff2";